import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactSupport from "../pages/ContactSupport";
import DisputeResolutionForm from "../pages/DisputeResolutionForm";
import SMQ1 from "../pages/SMQ1";
import SMQ2 from "../pages/SMQ2";
import SMQ3 from "../pages/SMQ3";
import BPQ1 from "../pages/BPQ1";
import BPQ2 from "../pages/BPQ2";
import BPQ3 from "../pages/BPQ3";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact-support",
    element: <ContactSupport />,
  },
  {
    path: "/dispute-resolution-form",
    element: <DisputeResolutionForm />,
  },
  {
    path: "/cancelling-my-subscription",
    element: <SMQ1 />,
  },
  {
    path: "/subscription-automatically",
    element: <SMQ2 />,
  },
  {
    path: "/never-received-the-product",
    element: <SMQ3 />,
  },
  {
    path: "/where-is-my-refund",
    element: <BPQ1 />,
  },
  {
    path: "/I-dont-recognize-this-charge",
    element: <BPQ2 />,
  },
  {
    path: "/I-was-unaware-of-the-charges",
    element: <BPQ3 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;